<template>
  <div>
    <follow @follow="followFn"></follow>
    <div
      :style="{
        'min-height': perCenter.vip_imgurlnew ? '1.74rem' : 'auto',
        'margin-top': follow ? '0.5rem' : '0'
      }"
      class="viplevel"
    >
      <img
        class="flex-s"
        v-if="!tourists"
        :src="perCenter.vip_imgurlnew ? perCenter.vip_imgurlnew : ''"
      />
      <img class="flex-s" v-else-if="!loading" src="/static/images/percen/notlogin_bg@2x.png" />
      <div
        class="viplevel_content"
        v-if="!loading"
        :style="{
          position: !tourists ? (perCenter.vip_imgurlnew ? 'absolute' : 'initial') : 'absolute'
        }"
      >
        <header>
          <ul class="headPortrait">
            <li>
              <div v-if="!tourists" @click="goInfo">
                <img
                  v-if="perCenter.head"
                  :src="perCenter.head"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorHeadImg
                      img.onerror = null
                    }
                  "
                />
                <img v-else :src="errorHeadImg" />
              </div>
              <div v-else @click="loginInfo('touch')">
                <img
                  v-if="perCenter.head"
                  :src="perCenter.head"
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorHeadImg
                      img.onerror = null
                    }
                  "
                />
                <img v-else :src="errorHeadImg" />
              </div>
              <div v-if="!tourists" class="editor" @click="goInfo">
                <van-skeleton
                  title
                  :row="1"
                  :loading="loading"
                  row-width="1.5rem"
                  title-width="1rem"
                >
                  <p class="flex-ac" :style="{ color: perCenter.vip_color }">
                    <span class="over-ell-1">{{ perCenter.smallname }}</span>
                    <img
                      v-if="perCenter.vip_levelvalue"
                      :src="'/static/images/vipIcon/l' + perCenter.vip_levelvalue + '.png'"
                    />
                  </p>
                  <b>
                    <img :src="perCenter.vip_editorimg" />
                    编辑个人资料
                  </b>
                </van-skeleton>
              </div>
              <div v-else class="editor" @click="loginInfo('touch')">
                <van-skeleton :row="1" :loading="loading" row-width="1rem">
                  <p>
                    登录/注册
                    <van-icon name="arrow" size="0.16rem" />
                  </p>
                </van-skeleton>
              </div>
            </li>
            <li>
              <img @click="setting" :src="perCenter.vip_settingimg" />
              <img @click="goMessage(1)" :src="perCenter.vip_messageimg" />
              <i v-if="perCenter.has_new_msg == 1" class="tags"></i>
            </li>
          </ul>
        </header>
        <p
          v-if="!tourists"
          class="f12 vip_money flex-js-ac"
          :style="{ color: perCenter.vip_color }"
          @click="govipcenter"
        >
          {{ perCenter.vip_leveldesc }}
          <!--          <img src="/static/images/percen/vipentr@2x.png" alt="">-->
        </p>
        <div v-if="!tourists" class="level_explain">
          <ul class="flex-js-ac" ref="vip_moneylevel" v-if="perCenter.vip_moneylevel">
            <li v-for="(item, index) of perCenter.vip_moneylevel">
              <p class="f12" :style="{ color: index == 0 ? 'transparent' : perCenter.vip_color }">
                {{ '￥' + parseFloat(item.money) }}
              </p>
              <b
                :style="
                  parseFloat(perCenter.vip_money) >= parseFloat(item.money)
                    ? { background: '#ffffff' }
                    : {}
                "
              ></b>
              <p
                class="f12 fb"
                :style="{
                  color: index == perCenter.vip_levelvalue ? '#FC0324' : perCenter.vip_color
                }"
              >
                {{ item.level }}
              </p>
            </li>
          </ul>
          <div class="line" :style="line">
            <div class="writeline" :style="{ width: percent + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
    <header>
      <ul class="classification">
        <li @click="integralClick(1)">
          <b>{{ perCenter.integral ? perCenter.integral : 0 }}</b>
          <span>金币</span>
          <div class="bubble" v-if="isSignin"></div>
        </li>
        <li class="hr"></li>
        <li @click="couponClick">
          <b>{{ perCenter.coupon_num ? perCenter.coupon_num : 0 }}</b>
          <span>卡劵</span>
        </li>
        <li class="hr"></li>
        <li @click="prizeClick">
          <b>{{ perCenter.prize_num ? perCenter.prize_num : 0 }}</b>
          <span>奖品</span>
        </li>
        <!--        皮肤测试入口屏蔽-->
        <!--        <li class="hr"></li>-->
        <!--        <li @click="handleSkinResult(1)">-->
        <!--          <b v-if="perCenter.skin_age && perCenter.skin_age > 0">{{perCenter.skin_age ? perCenter.skin_age : 0}}</b>-->
        <!--          <img v-else src="/static/images/percen/skin_click@3x.gif" alt="">-->
        <!--          <span>肌龄</span>-->
        <!--        </li>-->
      </ul>
    </header>
    <div class="vipupentr" v-if="perCenter.vipupimg" @click="vipupHandle">
      <img :src="perCenter.vipupimg" />
    </div>
    <swiper
      v-if="perCenter.bannerlist && perCenter.bannerlist.length"
      id="swiperBanner"
      :options="bannerSwiper"
    >
      <swiper-slide v-for="(item, index) of perCenter.bannerlist" :key="index">
        <img
          :src="item.img_path"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorImg
              img.onerror = null
            }
          "
        />
        <div
          :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
        ></div>
      </swiper-slide>
    </swiper>
    <act-coupon></act-coupon>
    <div class="redPackage" v-if="redPackageStatus == 1" @click="showRedPackage">
      <img src="../../assets/images/redPackage.png" />
      领取微信红包封面
    </div>
    <nav>
      <div class="ordertitle flex-js-ac">
        <b class="f14">我的订单</b>
        <span class="f12 flex-ac" @click="orderClick(0)">
          全部订单
          <img src="../../assets/images/jt2.png" />
        </span>
      </div>
      <ul>
        <li @click="orderClick(1)">
          <div class="tagsImg">
            <i v-if="parseInt(perCenter.wait_pay) > 0 && parseInt(perCenter.wait_pay) <= 99">
              {{ parseInt(perCenter.wait_pay) }}
            </i>
            <i v-else-if="parseInt(perCenter.wait_pay) > 99">99+</i>
            <img src="../../assets/images/noMoney.png" />
          </div>
          <span>待付款</span>
        </li>
        <li @click="orderClick(5)">
          <div class="tagsImg">
            <i
              v-if="parseInt(perCenter.wait_deliver) > 0 && parseInt(perCenter.wait_deliver) <= 99"
            >
              {{ parseInt(perCenter.wait_deliver) }}
            </i>
            <i v-else-if="parseInt(perCenter.wait_deliver) > 99">99+</i>
            <img src="../../assets/images/waitForRec.png" />
          </div>
          <span>待发货</span>
        </li>
        <li @click="orderClick(2)">
          <div class="tagsImg">
            <i
              v-if="parseInt(perCenter.wait_receipt) > 0 && parseInt(perCenter.wait_receipt) <= 99"
            >
              {{ parseInt(perCenter.wait_receipt) }}
            </i>
            <i v-else-if="parseInt(perCenter.wait_receipt) > 99">99+</i>
            <img src="../../../static/images/percen/shinshop@2x.png" />
          </div>
          <span>待收货</span>
        </li>
        <li @click="orderClick(3)">
          <div class="tagsImg">
            <i
              v-if="parseInt(perCenter.wait_comment) > 0 && parseInt(perCenter.wait_comment) <= 99"
            >
              {{ parseInt(perCenter.wait_comment) }}
            </i>
            <i v-else-if="parseInt(perCenter.wait_comment) > 99">99+</i>
            <img src="../../assets/images/noSay.png" />
          </div>
          <span>待评价</span>
        </li>
        <li @click="orderClick(4)">
          <div class="tagsImg">
            <i v-if="parseInt(perCenter.return_num) > 0 && parseInt(perCenter.return_num) <= 99">
              {{ parseInt(perCenter.return_num) }}
            </i>
            <i v-else-if="parseInt(perCenter.return_num) > 99">99+</i>
            <img src="../../assets/images/saleReturn.png" />
          </div>
          <span>退款/售后</span>
        </li>
      </ul>
    </nav>
    <ul class="flex flex-w feature">
      <li v-if="isemployees" @click="employeesFn">
        <img src="/static/images/percen/employees@2x.png" alt="" />
        <p class="f11">员工专属</p>
      </li>
      <li @click="integralClick(2)">
        <img src="/static/images/percen/integralprize@2x.png" alt="" />
        <p class="f11">金币兑礼</p>
      </li>
      <!--      皮肤测试入口屏蔽-->
      <!--      <li @click="handleSkinResult(2)">-->
      <!--        <img src="/static/images/percen/aiskin@2x.png" alt="">-->
      <!--        <p class="f11">AI测肤</p>-->
      <!--      </li>-->

      <!--      福利订阅-->
      <!--      <li>-->
      <!--        <img src="/static/images/percen/subscribe@2x.png" alt="">-->
      <!--        <p class="f11">福利订阅</p>-->
      <!--      </li>-->
      <li @click="footprintClick">
        <img src="/static/images/percen/footprint@2x.png" alt="" />
        <p class="f11">浏览足迹</p>
      </li>
      <li @click="soldClick">
        <img src="/static/images/percen/collect@2x.png" alt="" />
        <p class="f11">我的收藏</p>
      </li>
      <li @click="addressClick">
        <img src="/static/images/percen/address@2x.png" alt="" />
        <p class="f11">收货地址</p>
      </li>
      <li @click="keFu">
        <img src="/static/images/percen/kefu@2x.png" alt="" />
        <p class="f11">联系客服</p>
      </li>
      <li @click="goMessage(2)">
        <div class="tagsImg">
          <i v-if="parseInt(perCenter.new_msg_num) > 0 && parseInt(perCenter.new_msg_num) <= 99">
            {{ parseInt(perCenter.new_msg_num) }}
          </i>
          <i v-else-if="parseInt(perCenter.new_msg_num) > 99">99+</i>
          <img src="/static/images/percen/message@2x.png" alt="" />
        </div>
        <p class="f11">消息中心</p>
      </li>
      <li v-if="storechangeShow" @click="storechangeFn">
        <img src="/static/images/percen/me-icon-store@2x.png" alt="" />
        <p class="f11">店铺转让</p>
      </li>
      <li @click="storeFn">
        <img src="/static/images/percen/store.png" alt="" />
        <p class="f11">店铺信息</p>
      </li>
      <li @click="cerClick">
        <img src="/static/images/percen/cer@2x.png" alt="" />
        <p class="f11">资质证书</p>
      </li>
      <li @click="aboutClick">
        <img src="/static/images/percen/aboutUs.png" alt="" />
        <p class="f11">关于我们</p>
      </li>
      <li @click="evalClick">
        <img src="/static/images/percen/opinion.png" alt="" />
        <p class="f11">意见反馈</p>
      </li>
      <!--      <li @click="donateClick">-->
      <!--        <img src="/static/images/percen/donate.png" alt="">-->
      <!--        <p class="f11">我的捐赠</p>-->
      <!--      </li>-->
      <!--      <li @click="invFriendClick">-->
      <!--        <img src="/static/images/percen/InviteFriends.png" alt="">-->
      <!--        <p class="f11">邀请好友</p>-->
      <!--      </li>-->
      <li @click="meetingClick">
        <img src="/static/images/percen/meetingicon.png" alt="" />
        <p class="f11">线下会议</p>
      </li>
    </ul>
    <div
      ref="recommend"
      style="padding-bottom: 0.1rem"
      v-if="productlist && productlist.length > 0"
    >
      <div style="padding: 0 0.1rem; background: #fff">
        <product-list
          :title="'精选好物'"
          :productlist="productlist"
          :markPointData="{ scenepoint: 'USER', scenedesc: 'recom' }"
        ></product-list>
      </div>
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
    </div>
    <footer-comp v-if="isNewPage != -1" :isNewPage="isNewPage" :footerIndex="footerIndex" :cartnum="cartnum"></footer-comp>
  </div>
</template>
<script>
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import productList from '../common/productList'
import {
  getCookie,
  setCookie,
  isWeixin,
  fenxiang,
  formateName,
  formateMobile,
  bannerClick,
  goXcxCreateBtnFn,
  kefu,
  pageStatus,
  qrcodeKefuLimits
} from '../../assets/common/js/config'
import Vue from 'vue'
import { Skeleton } from 'vant'
import actCoupon from '../common/coupon'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

Vue.use(Skeleton).use(VueAwesomeSwiper /* { default global options } */)
Vue.config.ignoredElements = ['wx-open-launch-weapp']

export default {
  name: 'personalCenter',
  data() {
    var that = this
    return {
      follow: null,
      loading: true,
      tourists: true,
      footerIndex: 4,
      isSignin: false,
      integralnum: null,
      perCenter: {},
      redPackageStatus: null,
      isemployees: 0,
      storechangeShow: 0,
      shopchangeinfo: null,
      applyid: '',
      cartnum: 0,
      isNewPage: -1,
      line: {},
      percent: 0,
      averagepercent: 0,
      vip_level: 0,
      skinInfo: {},
      productlist: [],
      isWx: isWeixin() ? 1 : 0,
      bannerSwiper: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        initialSlide: 0,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        slidesOffsetAfter: 20,
        watchOverflow: true,
        pagination: {
          el: '#bannerSwiperPagination',
          // clickable: true,
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function() {
            that.activeIndex = this.realIndex
          },
          click: function() {
            var activeIndex = this.realIndex
            that.bannerClick(
              that.perCenter.bannerlist[activeIndex],
              activeIndex,
              'userbanner-' + (activeIndex + 1)
            )
          }
        }
      },
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  mounted: function() {
    sessionStorage.removeItem('ckys_wx_bound_tel')
    sessionStorage.removeItem('ckys_wx_bound_area_code')
    // let url = this.$ajax.getNdoResult_URL
    // this.$customRequestAjax(url).then((res) => {
    //   if (res.data.code === 200) {
    //     this.skinInfo = res.data
    //   }
    // })
  },
  activated() {
    pageStatus((status) => (this.isNewPage = status))
  },
  beforeRouteEnter: function(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next(function(vm) {
        vm.getData()
        pageStatus((status) => (vm.isNewPage = status))
        if (isWeixin()) {
          fenxiang({ path: 'personalcenter' })
        }
      })
    } else {
      next(function(vm) {
        sessionStorage.removeItem('ckys_wx_bound_tel')
        sessionStorage.removeItem('ckys_wx_bound_area_code')
        vm.getData()
        if (isWeixin()) {
          fenxiang({ path: 'personalcenter' })
        }
      })
    }
  },
  beforeRouteLeave: function(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop) || parseInt(window.pageYOffset)
    next()
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  components: {
    productList,
    footerComp,
    follow,
    actCoupon,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  methods: {
    getData: function() {
      var url = this.$ajax.getMeInfo_URL,
        recommendUrl = this.$ajax.getReCommendItemList_URL,
        that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.cartnum = res.data.cartnum
          // 登录校验
          if (
            !isWeixin() &&
            this.waptoken.waptoken &&
            this.waptoken.waptoken == this.waptoken.tourists
          ) {
            that.tourists = true
            that.loading = false
          } else {
            f()
          }
          if (res.data.redenv && res.data.redenv.status == 1) {
            that.getJumpUrl(res.data.redenv)
          }

          function f() {
            that.tourists = false
            that.perCenter = res.data
            if (that.perCenter.vip_moneylevel)
              that.averagepercent = 100 / (that.perCenter.vip_moneylevel.length - 1)
            let time = 0
            if (that.perCenter.vip_moneylevel) {
              that.perCenter.vip_moneylevel.map((item, index) => {
                try {
                  let lastmoney = parseFloat(that.perCenter.vip_moneylevel[index - 1].money)
                  if (parseFloat(item.money) > parseFloat(that.perCenter.vip_money) && time == 0) {
                    that.vip_level = index
                    time = 1
                    let money = parseFloat(item.money) - lastmoney
                    let p =
                      ((money - (parseFloat(item.money) - parseFloat(that.perCenter.vip_money))) /
                        money) *
                      100
                    let t = 100 / p
                    that.percent =
                      that.averagepercent / t +
                      (that.vip_level ? that.vip_level - 1 : 0) * that.averagepercent
                  } else if (parseFloat(item.money) <= parseFloat(that.perCenter.vip_money)) {
                    that.percent = that.averagepercent * index
                  }
                } catch (e) {}
              })
            }
            that.isemployees = parseInt(that.perCenter.isemployees)
            that.storechangeShow = that.perCenter.showshopchange
            that.shopchangeinfo = that.perCenter.shopchangeinfo
            that.applyid = that.shopchangeinfo.id ? that.shopchangeinfo.id : ''
            // 登录校验
            if (!isWeixin()) {
              if (that.waptoken.waptoken && that.waptoken.waptoken == that.waptoken.tourists) {
                that.loginInfo()
              } else {
                if (that.perCenter.sign === '0') {
                  that.isSignin = true
                } else if (that.perCenter.sign === '1') {
                  that.isSignin = false
                }
              }
            } else {
              if (that.perCenter.sign === '0') {
                that.isSignin = true
              } else if (that.perCenter.sign === '1') {
                that.isSignin = false
              }
            }
            that.$nextTick(function() {
              try {
                let left = that.$refs.vip_moneylevel.childNodes[0].clientWidth / 2
                let right =
                  that.$refs.vip_moneylevel.childNodes[
                    that.$refs.vip_moneylevel.childNodes.length - 1
                  ].clientWidth / 2
                that.line = {
                  left: left / 100 + 'rem',
                  right: right / 100 + 'rem'
                }
              } catch (e) {
                console.log(e)
              }
            })
            that.perCenter.birthdate = that.perCenter.birthdate.replace(/-/g, '/')
            sessionStorage.setItem('personal_information', JSON.stringify(that.perCenter))
            that.loading = false
            that.dataCollection(that.perCenter)
            that.setDataInfo(res.data)
            that.$nextTick(() => {
              setTimeout(function() {
                goXcxCreateBtnFn(that)
              }, 500)
            })
          }
        }
      })
      that.$customRequestAjax(recommendUrl).then((res) => {
        if (res.data.code === 200) {
          that.productlist = res.data.itemlist
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    bannerClick: function(items, index, flowArea) {
      bannerClick(
        items,
        index,
        flowArea,
        this,
        () => {
          this.dataCollection_act(items, index, flowArea)
        },
        'USER'
      )
    },
    dataCollection_act(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    setDataInfo(info) {
      this.tourists = false
      this.perCenter = info
      this.isSignin = this.perCenter.sign === '0' ? true : false
      this.perCenter.birthdate = this.perCenter.birthdate.replace(/-/g, '/')
      sessionStorage.setItem('personal_information', JSON.stringify(this.perCenter))
      this.loading = false
    },
    // 埋点-登录
    dataCollection(perCenter) {
      if (!getCookie('loginType')) {
        let smallname = formateName(perCenter.smallname)
        let mobile = formateMobile(perCenter.mobile)

        gio('people.set', 'userContact_ppl', mobile)
        gio('people.set', 'userName_ppl', smallname)
        gio('people.set', 'gender_ppl', perCenter.sex)
        setCookie('loginType', 1)
      }
    },
    followFn: function(data) {
      this.follow = data
    },
    goInfo: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '编辑个人资料'
        },
        callback: () => {
          this.$router.push('/perinfo')
        }
      })
    },
    loginInfo: function(type) {
      if (type == 'touch') {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'mepage',
            buttontext: '登录/注册'
          }
        })
      }
      this.$router.push({
        path: '/login',
        query: {
          routeval: 'percen'
        }
      })
    },
    setting: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '设置'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              sessionStorage.setItem('ckys4_mobile', this.perCenter.mobile)
              this.$router.push('/setting')
            }
          } else {
            sessionStorage.setItem('ckys4_mobile', this.perCenter.mobile)
            this.$router.push('/setting')
          }
        }
      })
    },
    goMessage: function(type) {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: type == 1 ? '消息' : '消息中心'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/messagecenter')
            }
          } else {
            this.$router.push('/messagecenter')
          }
        }
      })
    },
    cerClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '资质证书'
        },
        callback: () => {
          window.location.href =
            'http://ckysappserver.ckc8.com/front/ckappFront/html/news/ckappryzz/115.html'
        }
      })
    },
    aboutClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '关于我们'
        },
        callback: () => {
          this.$router.push('/aboutus')
        }
      })
    },
    // 获取跳转小程序链接
    getJumpUrl(info) {
      if (isWeixin()) {
        this.jumpUrl = info.url
        this.redPackageStatus = 1
      } else {
        let that = this,
          url = this.$ajax.getMyWapRedenv_URL
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200 && res.data.redenv) {
            that.jumpUrl = res.data.redenv.url || ''
            that.redPackageStatus = 1
          }
        })
      }
    },
    vipupHandle() {
      this.$router.push('/vip')
    },
    // 红包封面
    showRedPackage() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '领取微信红包封面'
        },
        callback: () => {
          location.href = this.jumpUrl
        }
      })
    },
    soldClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '我的收藏'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/collect')
            }
          } else {
            this.$router.push('/collect')
          }
        }
      })
    },
    footprintClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '浏览足迹'
        },
        callback: () => {
          this.$router.push('/footprint')
        }
      })
    },
    employeesFn: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '员工专属列表'
        },
        callback: () => {
          this.$router.push({
            path: '/exclusivelist'
          })
        }
      })
    },
    integralTask: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '金币兑礼'
        },
        callback: () => {
          this.$router.push({
            path: 'integralTask'
          })
        }
      })
    },
    handleSkinResult: function(type) {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: type == 1 ? '肌龄' : 'AI测肤'
        },
        callback: () => {
          if (this.skinInfo.orderid) {
            this.$router.push({
              path: '/analysisDetail',
              query: {
                orderid: this.skinInfo.orderid,
                source: 'records',
                sex: this.skinInfo.sex
              }
            })
          } else {
            this.$router.push({
              path: '/skinAnalysis'
            })
          }
        }
      })
    },
    keFu: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '联系客服'
        },
        callback: () => {
          qrcodeKefuLimits(3).then(() => {
            kefu()
          })
        }
      })
    },
    donateClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '我的捐赠'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/donate')
            }
          } else {
            this.$router.push('/donate')
          }
        }
      })
    },
    prizeClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '奖品'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/prize')
            }
          } else {
            this.$router.push('/prize')
          }
        }
      })
    },
    evalClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '意见反馈'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/feedback')
            }
          } else {
            this.$router.push('/feedback')
          }
        }
      })
    },
    addressClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '收货地址'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/addmana')
            }
          } else {
            this.$router.push('/addmana')
          }
        }
      })
    },
    orderClick: function(id) {
      // 待支付弹窗提醒支付成功埋点清除
      sessionStorage.removeItem('unpaypopup-pay')
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext:
            id == 0
              ? '全部订单'
              : id == 1
              ? '待付款'
              : id == 2
              ? '待收货'
              : id == 3
              ? '待评价'
              : id == 4
              ? '退款/售后'
              : '待发货'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/myorder')
              this.$store.commit('ORDERLIST_NAVID', id)
            }
          } else {
            this.$router.push('/myorder')
            this.$store.commit('ORDERLIST_NAVID', id)
          }
        }
      })
    },
    couponClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '卡劵'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/cashcoupon')
            }
          } else {
            this.$router.push('/cashcoupon')
          }
        }
      })
    },
    integralClick: function(type) {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: type == 1 ? '金币' : '金币兑礼'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              sessionStorage.setItem('ckys_sign', this.perCenter.sign)
              this.$router.push({
                path: '/integral'
              })
            }
          } else {
            sessionStorage.setItem('ckys_sign', this.perCenter.sign)
            this.$router.push({
              path: '/integral'
            })
          }
        }
      })
    },
    govipcenter: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '会员中心'
        },
        callback: () => {
          sessionStorage.removeItem('vipCenter_activeIndex')
          this.$router.push({
            path: '/vipcenter'
          })
        }
      })
    },
    storechangeFn: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '店铺转让'
        },
        callback: () => {
          if (this.shopchangeinfo.type == 1) {
            let url = this.$ajax.webcheckUserinfo_URL,
              data = {
                applyid: this.applyid
              }
            this.$customRequestAjax.post(url, data).then((res) => {
              if (res.data.code == 200) {
                link()
              } else {
                this.$dialog
                  .alert({
                    message: res.data.msg,
                    className: 'percen_button_alert integral_button_alert',
                    messageAlign: 'center',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '我知道了',
                    closeOnPopstate: false
                  })
                  .then(function() {
                    // on confirm
                  })
              }
            })
          } else {
            link()
          }
        }
      })
      var that = this
      function link() {
        sessionStorage.removeItem('bank_name_choose_item')
        that.$router.push({
          path: that.shopchangeinfo.stage == 3 ? '/personinfofill' : '/identityauthsucc',
          query: {
            storeid: that.shopchangeinfo.id ? that.shopchangeinfo.id : '',
            storetype: that.shopchangeinfo.type ? that.shopchangeinfo.type : ''
          }
        })
      }
    },
    invFriendClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '邀请好友'
        },
        callback: () => {
          this.$toast('正在加紧开发中，敬请期待')
        }
      })
    },
    storeFn: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '店铺信息'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              this.$router.push('/storeinfo')
            }
          } else {
            this.$router.push('/storeinfo')
          }
        }
      })
    },
    meetingClick: function() {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'mepage',
          buttontext: '线下会议'
        },
        callback: () => {
          // 登录校验
          if (!isWeixin()) {
            if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
              this.loginInfo()
            } else {
              window.location.href = '/static/wx/html/meeting/registrationlist.html'
            }
          } else {
            window.location.href = '/static/wx/html/meeting/registrationlist.html'
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.viplevel {
  /*background: linear-gradient(180deg,rgba(255,255,255,1), rgba(255,255,255,0));*/
  position: relative;
  img {
    width: 100%;
  }
  .viplevel_content {
    padding: 0.14rem 0.11rem 0.1rem;
    position: absolute;
    left: 0.11rem;
    bottom: 0;
    top: 0;
    right: 0.11rem;
    p {
      color: #333333;
      &.vip_money {
        margin-top: 0.18rem;
        img {
          width: 0.56rem;
          height: 0.17rem;
        }
      }
    }
    .level_explain {
      width: 100%;
      margin-top: 0.12rem;
      position: relative;
      ul {
        position: relative;
        z-index: 1;
        li {
          p {
            color: #333333;
            text-align: center;
          }
          b {
            display: block;
            width: 0.07rem;
            height: 0.07rem;
            background: #b2b7bf;
            border-radius: 50%;
            margin: 0.02rem auto 0.04rem;
          }
        }
      }
      .line {
        height: 0.03rem;
        background: linear-gradient(270deg, #b6bac2 0%, #b0b6be 100%);
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin-top: -0.02rem;
        .writeline {
          height: 0.03rem;
          width: 1rem;
          background: #ffffff;
          box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.3);
          border-radius: 2px;
          transition: all 0.4s;
        }
      }
    }
  }
}
.vipupentr {
  margin: 0.1rem 0.11rem;
  img {
    width: 100%;
    display: block;
  }
}
.redPackage {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.1rem 0.11rem;
  padding: 0 0.15rem;
  height: 0.4rem;
  font-size: 0.15rem;
  color: #f05541;
  background: #fff;
  img {
    width: 0.18rem;
    height: 0.18rem;
    margin-right: 0.06rem;
  }
}
header {
  /*margin-bottom: 0.1rem;*/
}
.swiper-container {
  height: 0.95rem;
  margin: 0.1rem 0.11rem;
  .swiper-wrapper {
    width: 100%;
    padding: 0 0.1rem;
    box-sizing: border-box;
    .swiper-slide {
      img {
        width: 100%;
        height: 100%;
        /*object-fit: cover;*/
      }
    }
  }
}
.headPortrait {
  /*background: #fff;
    margin-bottom: -0.005rem;
    padding: 0.09rem 0.13rem 0.12rem 0.15rem;*/
  &,
  li {
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -moz-justify-content: space-between;
    -o-justify-content: space-between;
    -ms-justify-content: space-between;
  }
  li {
    &:first-child {
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      img {
        width: 0.56rem;
        height: 0.56rem;
        border-radius: 50%;
      }
      .editor {
        font-size: 0;
        margin-left: 0.13rem;
        p {
          font-size: 0.2rem;
          color: #000000;
          margin-bottom: 0.04rem;
          width: 1.8rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          span {
            max-width: 80%;
          }
          img {
            width: 0.32rem;
            height: 0.15rem;
            border-radius: 0;
          }
        }
        b {
          color: #fe5e00;
          font-size: 0.13rem;
          font-weight: 400;
          img {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.03rem;
            float: left;
          }
        }
      }
    }
    &:last-child {
      position: relative;
      img {
        width: 0.23rem;
        height: 0.23rem;
        margin-left: 0.22rem;
      }
      .tags {
        width: 0.05rem;
        height: 0.05rem;
        background: #fc0324;
        border-radius: 50%;
        display: block;
        position: absolute;
        right: -0.03rem;
        top: 0;
      }
    }
  }
}
.classification {
  background: #fff;
  padding: 0.14rem 0 0.13rem;
  display: flex;
  display: -webkit-flex;
  display: -ms-flex;
  display: -o-flex;
  display: -moz-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -moz-justify-content: space-between;
  -o-justify-content: space-between;
  -ms-justify-content: space-between;
  align-items: center;
  -webkit-align-items: center;
  -moz-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  li {
    width: 35%;
    position: relative;
    &:nth-of-type(2) {
      width: 30%;
    }
    img {
      width: 0.2rem;
      height: 0.2rem;
      margin: 0 auto;
    }
    b {
      font-size: 0.14rem;
      color: #333333;
      display: block;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.04rem;
    }
    span {
      font-size: 0.12rem;
      color: #999999;
      display: block;
      text-align: center;
    }
    &.hr {
      height: 0.43rem;
      width: 1px;
      background: #cccccc;
    }
    .bubble {
      width: 0.8rem;
      height: 0.33rem;
      background: url('/static/images/integral/signinpop.gif') no-repeat center;
      background-size: 100% 100%;
      font-size: 0.1rem;
      -webkit-transform: scale(0.9);
      -moz-transform: scale(0.9);
      -ms-transform: scale(0.9);
      -o-transform: scale(0.9);
      transform: scale(0.9);
      color: #895808;
      padding: 0.08rem 0.12rem 0.15rem;
      white-space: nowrap;
      position: absolute;
      left: 0.45rem;
      top: -70%;
    }
  }
}
nav {
  padding: 0.15rem;
  margin: 0.1rem 0.11rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.19rem 0 rgba(226, 228, 234, 0.75);
  border-radius: 0.1rem;
  position: relative;
  /*&:before {*/
  /*  content: "";*/
  /*  display: block;*/
  /*  width: 0.54rem;*/
  /*  height: 100%;*/
  /*  background: url(../../assets/images/shadow.png) no-repeat 0 0;*/
  /*  background-size: 100% 100%;*/
  /*  position: absolute;*/
  /*  right: 0.36rem;*/
  /*  top: 0;*/
  /*}*/
  .ordertitle {
    b {
      color: #222222;
    }
    span {
      color: #b2b2b2;
      img {
        width: 0.05rem;
        height: 0.1rem;
        margin-left: 0.04rem;
      }
    }
  }
  ul {
    margin-top: 0.18rem;
    display: flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -webkit-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -o-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    li {
      flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      -moz-flex: 1;
      &:nth-child(4) {
        /* box-shadow: 20px 0px 9px -16px rgba(202,202,202,0.5);*/
      }
      &:last-child {
        /* box-shadow: -0.2rem 0 0.13rem -0.13rem rgba(202,202,202,0.5), inset -0.2rem 0 0.13rem -0.13rem rgba(202,202,202,0.5); */
      }
      span {
        font-size: 0.11rem;
        color: #424242;
        display: block;
        text-align: center;
        position: relative;
      }
    }
  }
}
.feature {
  padding: 0.1rem 0;
  margin: 0.1rem 0.11rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.19rem 0 rgba(226, 228, 234, 0.75);
  border-radius: 0.1rem;
  li {
    width: 25%;
    padding: 0.1rem 0;
    img {
      width: 0.24rem;
      height: 0.24rem;
      margin: auto;
    }
    p {
      text-align: center;
      margin-top: 0.08rem;
    }
  }
}
.tagsImg {
  width: 0.24rem;
  margin: 0 auto;
  position: relative;
  i {
    display: flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    display: -webkit-flex;
    align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    -webkit-align-items: center;
    justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    -moz-justify-content: center;
    -webkit-justify-content: center;
    font-style: normal;
    position: absolute;
    min-width: 0.15rem;
    height: 0.15rem;
    background: rgba(252, 3, 36, 1);
    font-size: 0.1rem;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 0.15rem;
    right: -20%;
    top: -15%;
  }
  img {
    width: 0.24rem;
    height: 0.24rem;
    margin-bottom: 0.08rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/personalCenter.vue